import { useQuery } from "@tanstack/react-query"
import { getBackofficeScheduledReportsQuery } from "modules/backoffice/lib/scheduledReports/getBackofficeScheduledReportsQuery"

export function useGetBackofficeScheduledReportsQuery(
  ...args: Parameters<typeof getBackofficeScheduledReportsQuery>
) {
  return useQuery(getBackofficeScheduledReportsQuery(...args))
}
